// extracted by mini-css-extract-plugin
export var active = "_iz-2";
export var recordingDot = "_iz-1";
export var recordingIndicator = "_iz-0";